module.exports = __webpack_public_path__ + "img/certificate_head.2df4fed3.png";